import { render } from "./submitDialog.vue?vue&type=template&id=2ceaccd2&scoped=true"
import script from "./submitDialog.vue?vue&type=script&lang=js"
export * from "./submitDialog.vue?vue&type=script&lang=js"

import "./submitDialog.vue?vue&type=style&index=0&id=2ceaccd2&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceaccd2"]])

export default __exports__